module.exports = __webpack_public_path__ + "img/ios_n.0dbfea9e.png";